import { render, staticRenderFns } from "./user-consume.vue?vue&type=template&id=54cfed65&scoped=true&"
import script from "./user-consume.vue?vue&type=script&lang=js&"
export * from "./user-consume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cfed65",
  null
  
)

export default component.exports